import React from 'react';

import { formProps } from "./Funding";
import MortgageForm from "../../../../data-capture/MortgageForm";

// Gift details live on the requirement - shared with the Balance of Funds gifts card
export const receivingGiftsQuestion = {
    label: "Gifts Included",
    text: "Will your deposit include gifts from relatives/ or friends?",
    name: "receivingGifts",
    answer: {
        type: "choice",
        choices: [
            {
                text: "Yes",
                value: true,
            },
            {
                text: "No",
                value: false,
            }
        ]
    },
    model: "requirement",
    rules: [],
    target: `requirement.receivingGifts`
}
export const depositGiftsQuestion = {
    label: 'Total Gifts',
    name: 'depositGifts',
    text: 'Value of all gifts',
    model: 'requirement',
    answer: {
        type: 'euro',
        step: 1000
    },
    hides: (form) => {
        return form.getFieldValue('receivingGifts') === false
    },
    rules: [

        {type: 'number', min: 1, message: "The minimum value here is €1"},
        {type: 'number', max: 1000000, message: "The maximum value here is €1,000,000"}
    ],
    target: `requirement.depositGifts`
}
export const giftersQuestion = {
    name: "gifters",
    answer: {
        type: "gifters",
    },
    hides: (form)=>{
        return form.getFieldValue('receivingGifts') !== true
    },
    label: "Names and Relationships of Gifters",
    text: "Please provide the names and relationships of the people who will be gifting you money towards this mortgage",
    model: "requirement",
    target: `requirement.gifters`
}
export const giftQuestions = () => [receivingGiftsQuestion, depositGiftsQuestion, giftersQuestion]

function DepositDetails() {

    const questions = [
        receivingGiftsQuestion,
        depositGiftsQuestion,
        {
            label: 'Claimed Funds',
            name: 'depositSavings',
            text: 'Own savings amount',
            model: 'requirement',
            answer: {
                type: 'euro',
                step: 1000
            },
            rules: [

                {type: 'number', min: 1, message: "The minimum value here is €1"},
                {type: 'number', max: 1000000, message: "The maximum value here is €1,000,000"}
            ],
            target: `requirement.depositSavings`
        },
        giftersQuestion,
    ]
    const formStyle = {
        width: '100%',
        maxWidth: 400
    }
    return (
        <MortgageForm style={formStyle} questions={questions} title="Source of Funds Details" formProps={formProps}/>

    )
}


export default DepositDetails;
